import { Col, Row } from "react-bootstrap";

export default function PageTitle(props) {
	return 	<Row className="my-5">
				<Col xs={12} ><h2 className="text-center">{props.text}</h2></Col>
			</Row>
}